(ns ui.view.card.shared-components.full-screen-card
  (:require
   [ui.util :as uu]
   [common.localization :as loc]
   [ui.components.button.view :as button]
   [ui.view.card.event :as event]
   [re-frame.core :as rf]))

(defn container
  [& children]
  [:div
   {:class "fixed top-0 left-0 flex flex-col z-[102] w-screen max-w-full h-screen max-h-screen overflow-hidden bg-base-light"}
   (into [:<>] children)])

(defn close-button
  [{:keys [ctx] :as _props}]
  [button/square-secondary-hollow
   {:on-click #(rf/dispatch [::event/toggle-full-screen ctx])}
   [:i.fal.fa-times]])

(defn prev-next-button
  [{:keys [caret-direction on-click disabled?]}]
  [:button
   {:class (uu/cm "h-8 w-8 m-0 inline-flex items-center justify-center whitespace-nowrap font-medium transition-colors"
                  "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                  "bg-base-light hover:bg-complement-regular disabled:pointer-events-none disabled:opacity-50"
                  "text-base-light-text text-sm")
    :on-click #(on-click)
    :disabled disabled?}
   (if (= caret-direction :up)
     [:i.fas.fa-caret-up
      {:class "text-2xl"}]
     [:i.fas.fa-caret-down
      {:class "text-2xl"}])])

(defn prev-next-card-buttons
  [{:keys [can-navigate-to-previous-card?
           can-navigate-to-next-card?
           on-navigate-to-previous-card
           on-navigate-to-next-card]}]
  [:div
   {:class "flex border border-solid border-base-light-border-paler rounded-md overflow-hidden items-center"}
   [:div
    {:class "border border-solid border-base-light-border-paler border-y-0 border-l-0"}
    [prev-next-button
     {:caret-direction :up
      :disabled? (not can-navigate-to-previous-card?)
      :on-click #(on-navigate-to-previous-card)}]]
   [prev-next-button
    {:disabled? (not can-navigate-to-next-card?)
     :on-click #(on-navigate-to-next-card)}]])

(defn header-right-edit-mode-tools
  [{:keys [saving-changes? unsaved-changes? discard-edits save-edits]}]
  [:div
   {:class "flex gap-2"}
   [button/sm-primary-solid
    {:on-click save-edits
     :disabled? (or (not unsaved-changes?)
                    saving-changes?)}
    (loc/tr :save)]
   [button/sm-secondary-hollow
    {:on-click discard-edits
     :disabled? saving-changes?}
    (loc/tr :cancel)]])

(defn header-right-default-tools
  [{:keys [can-edit-content? toggle-edit-mode
           navigation-between-cards-enabled?
           header-right-actions] :as props}]
  [:div
   {:class "flex gap-5 items-center"}
   (when header-right-actions
     header-right-actions)
   (when can-edit-content?
     [button/square-secondary-open
      {:on-click toggle-edit-mode}
      [:i.fal.fa-pencil]])
   (when navigation-between-cards-enabled?
     [prev-next-card-buttons props])
   [close-button props]])

(defn header-right
  [{:keys [edit-mode?] :as props}]
  (cond
    edit-mode? [header-right-edit-mode-tools props]
    :else [header-right-default-tools props]))

(defn header-left
  [{:keys [card entity-label entity-icon]}]
  (let [card-title (:card/title card)]
    [:div
     {:class "flex items-center gap-2"}
     [:i {:class (uu/cm "fal text-xl w-8 h-8 flex items-center justify-center bg-base-regular rounded" entity-icon)}]
     [:p {:class "font-bold text-xl"} entity-label]
     [:span {:class "text-xl font-medium"} " - "]
     [:p {:class "text-xl font-medium"} card-title]]))

(defn header
  [props]
  [:div
   {:class "py-4 px-6 flex items-center justify-between border-b border-solid border-base-light-border-paler"}
   [header-left props]
   [header-right props]])

(defn content
  [{:keys [content-class]} & children]
  [:div
   {:class (uu/cm "grow oveflow-hidden overflow-y-auto p-5 bg-white"
                  content-class)}
   (into [:<>] children)])

(defn view
  [props body]
  [container
   [header props]
   [content props body]])
